var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.images.length)?_c('ResponsiveMediaGallery',{attrs:{"items":_vm.images,"aspect-ratio":1.35,"grid-min-width":230,"aria-label":"Event gallery"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }